const minLength = {
  params: ['min'],
  validate (value, { min }) {
    return typeof value === 'string' && value.trim().length >= min
  },
}

export { minLength }
